import React,{useEffect,useState} from "react";
import StyleSliderItem from "../components/StyleSliderItem.js"

const loadStyle=(style_id)=>{
  let stylePromise=fetch(
    __server__ + '/API/pub/style/'+style_id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) =>response.json())

  let colorwaysPromise=fetch(
    __server__ + '/API/pub/colorways_by_style_id/'+style_id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) =>response.json())

  let resellsPromise=fetch(
    __server__ + '/API/pub/resells_by_style_id/'+style_id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) =>response.json())


  return(
    Promise.all([stylePromise,colorwaysPromise,resellsPromise]).then(([style,colorways,resells])=>{
      return({...style[0],colorways:colorways,resells:resells})
    })
  )
}



function LoadingStyleItem(props){
  const [styleItem,setStyleItem]=useState(0);

  useEffect(()=>{
    loadStyle(props.style_id).then((styleItem)=>{
      setStyleItem(styleItem)
    })
  },[])

  if(styleItem){
    return(
      <StyleSliderItem
        textContainerStyle={props.textContainerStyle}
        showShoeName={props.showShoeName}
        shoeName={styleItem.shoe_name}
        imageProps={props.imageProps}
        showLikeButton={props.showLikeButton}
        imageHeight={props.imageHeight}
        styleItem={styleItem}
        onClick={()=>{props.onClick(styleItem)}}
        swiperWidth={props.swiperWidth}/>
    )
  }
  else{
    return(
      <StyleSliderItem
        preview
        imageHeight={props.imageHeight}
        swiperWidth={props.swiperWidth}
        />
    )
  }
}

export default LoadingStyleItem;
